package com.ijoin.ui.screens

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.material.icons.filled.Favorite
import androidx.compose.material.icons.outlined.CalendarToday
import androidx.compose.material.icons.outlined.FavoriteBorder
import androidx.compose.material.icons.outlined.LocationOn
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.ijoin.i18n.strings
import com.ijoin.ui.payment.PaymentFlowArgs

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun EventDetailsScreen(
    eventId: String,
    onBackClick: () -> Unit,
    onBuyTicketClick: (com.ijoin.ui.payment.PaymentFlowArgs) -> Unit,
    modifier: Modifier = Modifier
) {
    // TODO: Load event details from repository
    var isFavorite by remember { mutableStateOf(false) }
    val strings = strings()

    Scaffold(
        topBar = {
            TopAppBar(
                title = { Text(strings.eventDetailsTitle) },
                navigationIcon = {
                    IconButton(onClick = onBackClick) {
                        Icon(Icons.Default.ArrowBack, contentDescription = strings.back)
                    }
                },
                actions = {
                    IconButton(onClick = { isFavorite = !isFavorite }) {
                        Icon(
                            imageVector = if (isFavorite) Icons.Filled.Favorite else Icons.Outlined.FavoriteBorder,
                            contentDescription = if (isFavorite) strings.removeFromFavorites else strings.addToFavorites,
                            tint = if (isFavorite) MaterialTheme.colorScheme.error else MaterialTheme.colorScheme.onSurface
                        )
                    }
                }
            )
        },
        bottomBar = {
            Surface(
                shadowElevation = 8.dp,
                tonalElevation = 0.dp
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(16.dp),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Button(
                        onClick = { onBuyTicketClick(PaymentFlowArgs(eventId = eventId)) },
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        Text(strings.book)
                    }
                }
            }
        }
    ) { paddingValues ->
        Column(
            modifier = modifier
                .fillMaxSize()
                .padding(paddingValues)
                .verticalScroll(rememberScrollState())
                .padding(16.dp),
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            // Event title
            Text(
                text = strings.eventTitle,
                style = MaterialTheme.typography.headlineMedium
            )

            // Organizer
            Text(
                text = "${strings.organizerLabel}: Event Organizer",
                style = MaterialTheme.typography.titleMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )

            Divider()

            // Date and time
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                Icon(
                    imageVector = Icons.Outlined.CalendarToday,
                    contentDescription = null,
                    tint = MaterialTheme.colorScheme.primary
                )
                Column {
                    Text(
                        text = strings.dateAndTime,
                        style = MaterialTheme.typography.labelMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                    Text(
                        text = "2025-01-15 19:00",
                        style = MaterialTheme.typography.bodyLarge
                    )
                }
            }

            // Location
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                Icon(
                    imageVector = Icons.Outlined.LocationOn,
                    contentDescription = null,
                    tint = MaterialTheme.colorScheme.primary
                )
                Column {
                    Text(
                        text = strings.location,
                        style = MaterialTheme.typography.labelMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                    Text(
                        text = "Location Name\nAddress, City",
                        style = MaterialTheme.typography.bodyLarge
                    )
                }
            }

            Divider()

            // Description
            Text(
                text = strings.description,
                style = MaterialTheme.typography.titleMedium
            )
            Text(
                text = strings.eventDescriptionPlaceholder,
                style = MaterialTheme.typography.bodyMedium
            )

            Divider()

            // Price tiers
            Text(
                text = strings.tickets,
                style = MaterialTheme.typography.titleMedium
            )

            // Placeholder for price tiers
            Card(
                modifier = Modifier.fillMaxWidth()
            ) {
                Column(modifier = Modifier.padding(12.dp)) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        Text(strings.ticketTierStandard, style = MaterialTheme.typography.bodyLarge)
                        Text("${strings.ticketPricePlaceholder} ₽", style = MaterialTheme.typography.titleMedium)
                    }
                    Text(
                        text = strings.ticketsAvailable(50),
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
            }
        }
    }
}
